/* eslint-disable import/prefer-default-export */
export const ADD_COUPON_ON_SUCCESS = 'ADD_COUPON_ON_SUCCESS'
export const UPDATE_COUPON_ON_SUCCESS = 'UPDATE_COUPON_ON_SUCCESS'
export const DELETE_COUPON_ON_SUCCESS = 'DELETE_COUPON_ON_SUCCESS'
export const TABLE_ROW_ON_CLICK = 'TABLE_ROW_ON_CLICK'
